var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vt-grid',{staticClass:"comp-grid my-1",attrs:{"grid-options":_vm.gridOptions,"column-defs":_vm.columnDefs,"row-data":_vm.rowData,"dom-layout":_vm.domLayout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }